/**
 * Periodos de liquidacion (mensuales o excepcionales como aguinaldo/bonos).
 * Alineado con el schema SQL en supabase/migrations.
 */

export interface Periodo {
  id: string;
  periodo: string; // YYYY-MM
  fecha_vencimiento: string; // ISO date
  version: number;
  estado: 'activo' | 'inactivo';
  descripcion: string | null;
  excepcional: boolean;
  created_at: string;
  updated_at: string;
}

export type PeriodoCreatePayload = Omit<Periodo, 'id' | 'created_at' | 'updated_at'>;
export type PeriodoUpdatePayload = Partial<PeriodoCreatePayload>;

/**
 * Construye una etiqueta amigable para mostrar:
 *   "Marzo 2026" - normal
 *   "Marzo 2026 (Aguinaldo)" - excepcional con descripcion
 */
const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export function getPeriodoLabel(p: Periodo): string {
  const [yyyy, mm] = p.periodo.split('-');
  const mesIdx = parseInt(mm, 10) - 1;
  const mes = mesIdx >= 0 && mesIdx < 12 ? MESES[mesIdx] : mm;
  const base = `${mes} ${yyyy}`;
  if (p.excepcional && p.descripcion) return `${base} (${p.descripcion})`;
  if (p.excepcional) return `${base} (Excepcional)`;
  return base;
}
